<template>
    <div class="grid grid-cols-2 lg:text-[18px] lg:w-[360px]">
        <button @click="$emit('update:modelValue', modelValue == 'upcoming' ? null : 'upcoming')"
            :class="[modelValue == 'upcoming' ? 'bg-primary-500 text-white border-primary-500' : 'bg-white hover:bg-primary-200', 'flex items-center justify-center duration-150 space-x-[12px] border-l border-y rounded-l-xl py-[5.5px] px-[10px]']">
            <svg v-if="modelValue == 'upcoming'" xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                viewBox="0 0 12 10" fill="none" class="w-[12px] h-[10px]">
                <path d="M1 4.33333L3.89933 8.00582C4.2997 8.51296 5.06872 8.51296 5.46909 8.00582L11 1" stroke="white"
                    stroke-width="2" stroke-linecap="round" />
            </svg>
            <span>Upcoming PD</span>
        </button>
        <button @click="$emit('update:modelValue', modelValue == 'ongoing' ? null : 'ongoing')"
            :class="[modelValue == 'ongoing' ? 'bg-primary-500 text-white border-primary-500' : 'bg-white hover:bg-primary-200', 'flex items-center justify-center duration-150 space-x-[12px] border-r border-y rounded-r-xl py-[5.5px] px-[10px]']">
            <svg v-if="modelValue == 'ongoing'" xmlns="http://www.w3.org/2000/svg" width="12" height="10"
                viewBox="0 0 12 10" fill="none">
                <path d="M1 4.33333L3.89933 8.00582C4.2997 8.51296 5.06872 8.51296 5.46909 8.00582L11 1" stroke="white"
                    stroke-width="2" stroke-linecap="round" />
            </svg>
            <span>Ongoing PD</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: String,
            default: null
        }
    }
}
</script>
